import { PUBLIC } from 'pricing-pages-ui/constants/AuthType';
import { getPublicPagePath } from 'pricing-pages-ui/utils/urls/publicUtils';
import PublicApp from './PublicApp';
const publicConfig = {
  authType: PUBLIC,
  rootUrl: getPublicPagePath(),
  defaultHubRoute: '/marketing'
};
new PublicApp(publicConfig).start().catch(() => {});